@let data = section();

<section class="cms-action tg-container tg-section">
    <div class="cms-action__card">
        @if (data.actionCardContent) {
            <div class="cms-content" [innerHTML]="data.actionCardContent | trustHtml"></div>
        }

        @if (data.buttonsList.length) {
            <div class="cms-action__actions">
                @for (button of data.buttonsList; track button.id) {
                    <cms-btn [config]="button" />
                }
            </div>
        }
    </div>
</section>
